export default __webpack_public_path__ + "static/media/Keplr2.116022f7.svg";